import React from 'react';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '@/lib/helpers';
import { Card, CardContent } from '@marine/ui/card';

interface BrandedAuthLayoutProps {
  children: React.ReactNode;
  variant?: 'admin' | 'dealer';
}

export const BrandedAuthLayout: React.FC<BrandedAuthLayoutProps> = ({ 
  children,
  variant = 'admin'
}) => {
  const lightBg = variant === 'admin' 
    ? '/media/images/auth/2600x1600/admin-login-light.png'
    : '/media/images/auth/2600x1600/dealer-login-light.png';
  
  const darkBg = variant === 'admin'
    ? '/media/images/auth/2600x1600/admin-login-dark.png'
    : '/media/images/auth/2600x1600/dealer-login-dark.png';

  const title = variant === 'admin'
    ? 'Secure Platform Access'
    : 'Dealer Portal Access';

  const description = variant === 'admin'
    ? (
      <>
        A robust authentication gateway ensuring
        <br />secure&nbsp;
        <span className="text-mono font-semibold">
          efficient user access
        </span>
        &nbsp;to the Marine Digital Management System
        <br />Platform interface.
      </>
    )
    : (
      <>
        Streamlined dealer authentication for
        <br />efficient&nbsp;
        <span className="text-mono font-semibold">
          marine dealership management
        </span>
        <br />and operations.
      </>
    );

  return (
    <>
      <style>
        {`
          .branded-bg-${variant} {
            background-image: url('${toAbsoluteUrl(lightBg)}');
          }
          .dark .branded-bg-${variant} {
            background-image: url('${toAbsoluteUrl(darkBg)}');
          }
        `}
      </style>
      <div className="grid lg:grid-cols-2 grow">
        <div className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1">
          <Card className="w-full max-w-[400px]">
            <CardContent className="p-6">
              {children}
            </CardContent>
          </Card>
        </div>

        <div className={`lg:rounded-xl lg:border lg:border-border lg:m-5 order-1 lg:order-2 bg-top xxl:bg-center xl:bg-cover bg-no-repeat branded-bg-${variant}`}>
          <div className="flex flex-col p-8 lg:p-16 gap-4">
            <Link to="/">
              <div className="text-2xl font-bold text-mono">
                Marine Digital Management System
              </div>
            </Link>

            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-semibold text-mono">
                {title}
              </h3>
              <div className="text-base font-medium text-secondary-foreground">
                {description}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
